import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography } from '@mui/material';

// Ficha de solo lectura con los datos administrativos del paciente -- pensada para consultarse
// sin salir del contexto clínico (Evolución médica, Historia Clínica). Mismo componente en los
// dos lugares para no duplicar lógica ni layout. Solo muestra los campos que el paciente
// efectivamente tiene cargados -- nunca inventa valores ni deja huecos vacíos a la vista.
const CAMPOS = [
  { key: 'dni', label: 'DNI' },
  { key: 'apellido', label: 'Apellido' },
  { key: 'nombre', label: 'Nombre' },
  { key: 'fecha_nacimiento', label: 'Fecha de nacimiento', formato: v => new Date(v).toLocaleDateString('es-AR', { timeZone: 'UTC' }) },
  { key: 'telefono', label: 'Teléfono' },
  { key: 'email', label: 'Email' },
  { key: 'obra_social', label: 'Obra social' },
  { key: 'numero_afiliado', label: 'Número de afiliado', vacio: 'No registrado' },
  { key: 'direccion', label: 'Dirección' },
];

const tieneValor = v => v !== null && v !== undefined && String(v).trim() !== '';

export default function DatosPacienteDialog({ open, onClose, paciente }) {
  const tieneObraSocial = tieneValor(paciente?.obra_social);
  const filas = CAMPOS
    .map(c => ({ ...c, valor: paciente?.[c.key] }))
    // El número de afiliado se muestra siempre que haya obra social (aunque esté vacío, con un
    // placeholder) -- una obra social sin su número no dice mucho. El resto de los campos siguen
    // ocultándose si no tienen valor cargado.
    .filter(c => tieneValor(c.valor) || (c.key === 'numero_afiliado' && tieneObraSocial));

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth
      PaperProps={{ sx: { bgcolor: 'var(--c-superficie)', border: '1px solid var(--c-primario)' } }}>
      <DialogTitle sx={{ color: 'var(--c-acento)', fontWeight: 700, fontSize: 16 }}>
        Datos del paciente
      </DialogTitle>
      <DialogContent>
        {filas.length === 0 ? (
          <Typography sx={{ color: '#90a4ae', fontSize: 13 }}>No hay datos administrativos cargados para este paciente.</Typography>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.2 }}>
            {filas.map(f => (
              <Box key={f.key} sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
                <Typography sx={{ fontSize: 12, color: '#78909c' }}>{f.label}</Typography>
                <Typography sx={{ fontSize: 13, color: tieneValor(f.valor) ? '#e0e0e0' : '#607d8b', textAlign: 'right', fontStyle: tieneValor(f.valor) ? 'normal' : 'italic' }}>
                  {tieneValor(f.valor) ? (f.formato ? f.formato(f.valor) : f.valor) : f.vacio}
                </Typography>
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ color: 'var(--c-acento)' }}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
}
